import NiceModal from "@ebay/nice-modal-react";
import {CustomDialog, Text} from "@bounce/shared/ui";

type Props = {
  onConfirm: (goLive: boolean) => void;
};

const GoLiveDialog = NiceModal.create(({onConfirm}: Props) => (
  <CustomDialog
    title="Save template"
    forceTitle
    buttonText="Save and go live"
    secondaryButtonText="Save as draft"
    onClick={() => onConfirm(true)}
    onClickSecondary={() => onConfirm(false)}
    width="380px"
  >
    <Text size={14}>
      This template is a draft. Save it as a draft, or go live to set its status to active?
    </Text>
  </CustomDialog>
));

export default GoLiveDialog;
